<template>
<div class="chapter">
<div class="inner_page">
<div class="forward">
<a id="pageii">
<p><span><b>Also by Harrison Owen</b></span></p><br/><br/>
<p><span><i>Spirit: Transformation and Development in Organizations</i></span></p><br/>
<p><span><i>Leadership Is</i></span></p><br/>
<p><span><i>Riding the Tiger</i></span></p><br/>
<p><span><i>The Millennium Organization</i></span></p><br/>
<p><span><i>Tales From Open Space</i></span></p><br/>
<p><span><i>Open Space Technology: A User’s Guide</i></span></p>
</a></div><a id="pageii">
</a>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// also.vue?3f253bc6